import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  scrollClass = 'scroll';
  title = 'Client';
  mySubscription: any;

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    this.mySubscription = this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.router.navigated = false;

        const url = event.urlAfterRedirects;

        // detecta si es móvil (ancho menor a 768px)
        const isMobile = window.innerWidth < 768;

        // if ((url.startsWith('/admin/nuevo') || url.startsWith('/admin/editar') || url.startsWith('/admin/principal')  ) && !isMobile  || ( url.startsWith('/admin/principal')   && isMobile))  {
         if ( url.startsWith('/admin/principal')  )  {
          this.scrollClass = 'no-scroll'; // escritorio → sin scroll
        }
         else {
          this.scrollClass = 'scroll'; // resto → con scroll
        }
      });
  }

  ngOnInit(): void {
    if (localStorage.getItem('session') != null) {
      this.router.navigate(['inicio']);
    }
  }

  ngOnDestroy() {
    if (this.mySubscription) {
      this.mySubscription.unsubscribe();
    }
  }
}
